// extracted by mini-css-extract-plugin
export default {"switch":"toggle_switch__-Lzs0","slider":"toggle_slider__sKmH1","round":"toggle_round__TzzJB"};